export default __webpack_public_path__ + "static/media/08.69f4c4a3.jpg";